import $ from 'jquery';
import debounce from 'lodash-es/debounce.js';
import config from './store/index.js';
import Cookies from './libs/tomcat-cookies';
import { isoCode, locale } from './store/cookies.js';
import { eventType } from './config/settings.js';
import selectedLanguageIcon from './components/language-selector/icon-selected.js';

let initialPos = -1;

function updateScrollPosition() {
	const $wrapper = document.getElementsByClassName('js-logo-wrapper')[0];
	const targetScale = 0.5;
	const scrolled = window.scrollY;

	if (initialPos < 0) {
		initialPos = (document.getElementsByClassName('landing-page-wrapper__logo-wrapper')[0]) ? $wrapper.getBoundingClientRect().top : 0;
	}

	if (scrolled - 2.0 > initialPos) {
		$wrapper.classList.add('is-collapsed');

		$wrapper.getElementsByClassName('svg-logo')[0].style.transform = `scale(${targetScale})`;
	} else {
		let scale;
		scale = 1.0 - (scrolled / initialPos);
		scale = (scale * 1.2) + targetScale;

		// bounds
		scale = scale > 1.0 ? 1.0 : scale;
		scale = scale < targetScale ? targetScale : scale;
		$wrapper.classList.remove('is-collapsed');
		$wrapper.getElementsByClassName('svg-logo')[0].style.transform = `scale(${scale}) translate(0%, -${scrolled / (scale * scrolled)}%)`;
	}
}

function getIsoCode() {
	if (!locale()) {
		return 'se';
	}
	const isoCodeStr = locale().substring(3, 6).toLowerCase();
	return isoCodeStr && isoCodeStr === 'xx' ? 'en' : isoCodeStr;
}
function changeLanguageFlag() {
	document.getElementsByClassName('landing-page__language-section-icon')[0].classList.add(`flag__${getIsoCode()}--square`, 'flag--square');
}


function changeLanguage(selectedLocale) {
	if (isoCode() !== selectedLocale) {
		Cookies.set('locale', selectedLocale, { path: '/' });
		changeLanguageFlag();
		location.reload();
	}
}

function init() {
	try {
		changeLanguageFlag();
		const $languageSelectionButton = document.getElementsByClassName('landing-page__language-section-icon')[0];
		const $languageSelectionPanel = document.getElementsByClassName('language-selector')[0];

		if ($languageSelectionButton && $languageSelectionPanel) {
			//we add the close event no matter what and make sure to clean the previously bound click event
			const $langSelPanelCloseBttn = $languageSelectionPanel.getElementsByClassName('icon-close')[0];
			const closeLangSelPanel = function () {
				$languageSelectionPanel.classList.remove('notify--is-open', 'slide-in-up');
				$languageSelectionPanel.classList.add('slide-out-down');
			};
			$langSelPanelCloseBttn.removeEventListener(eventType, closeLangSelPanel);
			$langSelPanelCloseBttn.addEventListener(eventType, closeLangSelPanel);

			//if there aren't any other language buttons, we dont need to bind any events here
			if ($languageSelectionPanel.getElementsByClassName('landing-page__language-section-icon')) {
				$languageSelectionButton.addEventListener(eventType, () => {
					const selectedLink = document.querySelector(`a[data-locale=${locale()}]`);
					const ifAlreadySelected = selectedLink.querySelector('.js-icon-selected');
					if (!ifAlreadySelected) {
						selectedLink.innerHTML += selectedLanguageIcon;
					}
					$languageSelectionPanel.classList.add('notify--is-open', 'slide-in-up');
					$languageSelectionPanel.classList.remove('slide-out-down');

				});
				// need to debounce this event so it doesn't trigger several times while scrolling.
				[].slice.call($languageSelectionPanel.getElementsByClassName('link-list__item')).forEach((v) => {
					v.addEventListener(eventType, (e) => {
						changeLanguage(e.target.getAttribute('data-locale'));
						return false;
					});
				});

			}
		}
	} catch (e) {
		console.error('language selection error', e);
	}

	if (config.page === 'landing') {
		window.addEventListener('scroll', debounce(updateScrollPosition, 5));
	}

	const $productButtons = document.getElementById('products').getElementsByClassName('product-button');
	if ($productButtons.length > 3) {
		const $shopButton = document.getElementById('shop');
		$shopButton.parentNode.removeChild($shopButton);
	}

	document.getElementById('products').classList.remove('u-hide');
}

function destroy() {
	//document.getElementsByClassName('landing-page__language-section-icon')[0].removeEventListener(eventType);
	//document.getElementsByClassName('language-selector')[0].removeEventListener(eventType);

	if (config.page === 'landing') {
		window.removeEventListener('scroll');
	}
}

export { init, destroy };



// WEBPACK FOOTER //
// ./mobile-core/src/landing-page.js